// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ChromeStorePluginUrl:'https://chrome.google.com/webstore/detail/deftgpt-ai-chat-gpt-writi/ofeanjpmjdifbpdcjakglfiphhdibokg?hl=en&authuser=0',
    // iconURL:"https://www.deftgpt.com/img/icons"
};